import { BaseTemplateElement } from './base-template-element.model';
import { Base } from './report-editor.model';
import { HistoricalAggregatedDatapointDto } from './template-dto.model';

export class ConsumptionTableElement extends BaseTemplateElement {
    description: string;
    datapoints: HistoricalAggregatedDatapointDto[];
    granularity: string;
    useTitle?: boolean;

    constructor(
        base: Base,
        description: string,
        datapoints: HistoricalAggregatedDatapointDto[],
        granularity: string,
        useTitle?: boolean,
    ) {
        super(base);
        this.description = description;
        this.datapoints = datapoints;
        this.granularity = granularity;
        this.useTitle = useTitle;
    }
}
